import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, Download, BookOpen, Tag } from "lucide-react";
import api, { API, authToken } from "../../lib/api";

function SideCard({ side, assigned }) {
  const openPdf = () => window.open(`${API}/sides/${side.id}/download?auth=${authToken()}`, "_blank");
  return (
    <div className="paper-card p-6 flex flex-col" data-testid={`side-card-${side.id}`}>
      <div className="flex items-start justify-between mb-3">
        <FileText size={22} className="text-brass" />
        {assigned && (
          <span className="font-mono text-[10px] uppercase tracking-wider text-confirmed border border-confirmed/40 px-2 py-0.5">
            Assigned to you
          </span>
        )}
      </div>
      <h3 className="font-serif text-2xl text-ink leading-tight">{side.title}</h3>
      <p className="font-mono text-xs text-stone mt-1">{side.page_count} pp.</p>
      {side.tags?.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {side.tags.map((t) => (
            <span key={t} className="font-sans text-[11px] text-stone flex items-center gap-1">
              <Tag size={10} /> {t}
            </span>
          ))}
        </div>
      )}
      <div className="flex gap-3 mt-5 pt-4 border-t border-hairline">
        <Link to={`/portal/sides/${side.id}`} className="btn-ghost text-brass text-sm font-semibold" data-testid={`read-side-${side.id}`}>
          <BookOpen size={15} /> Read
        </Link>
        <button onClick={openPdf} className="btn-ghost text-sm" data-testid={`download-side-${side.id}`}>
          <Download size={15} /> PDF
        </button>
      </div>
    </div>
  );
}

export default function PortalSides() {
  const [data, setData] = useState({ assigned: [], public: [] });

  useEffect(() => {
    api.get("/sides/mine").then((r) => setData(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-12" data-testid="portal-sides">
      <div>
        <p className="overline mb-2">Your scenes</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-ink tracking-tight">My Sides</h1>
        <p className="font-sans text-sm text-stone mt-2">
          Sides posted to you carry your name across the page. Get them off-book.
        </p>
      </div>

      <section>
        <h2 className="font-serif text-2xl text-ink mb-5">Assigned to you</h2>
        {data.assigned.length === 0 ? (
          <p className="font-sans text-sm text-stone">No sides posted to you yet.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {data.assigned.map((s) => (
              <SideCard key={s.id} side={s} assigned />
            ))}
          </div>
        )}
      </section>

      <section>
        <div className="brass-rule mb-8" />
        <h2 className="font-serif text-2xl text-ink mb-5">Studio library</h2>
        {data.public.length === 0 ? (
          <p className="font-sans text-sm text-stone">The public library is empty right now.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {data.public.map((s) => (
              <SideCard key={s.id} side={s} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
